const formStatusColor = (form) => {
  switch (form.status) {
    case 'CREATED':
      return { color: '#274c94', dark: true };
    case 'OPENED':
      return { color: 'black', dark: true }
    case 'SUBMITTED':
      return { color: '#ff9800', dark: true };
    case 'UNDER_WORK':
      return { color: '#cc00b8', dark: true };
    case 'CHECKED':
      return { color: '#66bb6a', dark: true };
    case 'PROCESSED':
      return { color: '#005F58', dark: true };
    default:
      return { color: 'gray', dark: false };
  }
}
export default formStatusColor;
